import { Modal, Spin } from 'antd';
import { BasePageComponent } from 'components';
import React, { useEffect, useState } from 'react';
import { CountryOfOriginSection, LanguageSection, RegionsSection } from '../components';
import { globalSettingService } from '../services/globalSettingService';
import { CountryInterface } from '../types/globalSettingType';

const GlobalSetting: React.FC = () => {
  const [countries, setCountries] = useState<CountryInterface[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await globalSettingService.fetchCountries(
        new URLSearchParams({ page_size: '1000' })
      );
      setCountries(response.results);
    } catch (error) {
      console.error('Failed to fetch countries:', error);
      Modal.error({
        title: 'Error',
        content: 'Failed to load countries',
        okText: 'Confirm',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasePageComponent>
      {loading ? (
        <div style={{ padding: '24px', textAlign: 'center' }}>
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ padding: '24px' }}>
          <h1>Global Setting</h1>
          <br />
          {/* Regions Section */}
          <RegionsSection countries={countries} onCountriesChange={fetchCountries} />

          {/* Country of Origin Section */}
          <CountryOfOriginSection />

          {/* Language Section */}
          <LanguageSection />
        </div>
      )}
    </BasePageComponent>
  );
};

export default GlobalSetting;
